module.exports = __webpack_public_path__ + "static/media/home-block-2@2x.5210f041.jpg";